/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'crossbarCircle': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M552.32 550.528l234.002-1.957a46.555 46.555 0 0 0-1.006-91.172l-232.996.037a9940.095 9940.095 0 0 1-91.502-1.317l-234.056 1.042a46.537 46.537 0 0 0 0 92.8l232.374.658c7.826 1.226 93.184-.091 93.184-.091z" _fill="#bfbfbf"/><path pid="1" d="M512 1024a508.836 508.836 0 0 1-199.314-40.23 510.317 510.317 0 0 1-162.742-109.713A510.298 510.298 0 0 1 40.23 711.314 508.762 508.762 0 0 1 0 512 508.799 508.799 0 0 1 40.23 312.686a510.372 510.372 0 0 1 109.714-162.742A510.335 510.335 0 0 1 312.686 40.23 508.708 508.708 0 0 1 512 0 508.708 508.708 0 0 1 711.314 40.23a510.335 510.335 0 0 1 162.743 109.714A510.372 510.372 0 0 1 983.77 312.686 508.799 508.799 0 0 1 1023.999 512a508.762 508.762 0 0 1-40.228 199.314 510.298 510.298 0 0 1-109.714 162.743A510.317 510.317 0 0 1 711.314 983.77 508.836 508.836 0 0 1 512 1023.999zm0-932.57A421.046 421.046 0 0 0 91.43 512 421.046 421.046 0 0 0 512 932.57 421.046 421.046 0 0 0 932.57 512 421.046 421.046 0 0 0 512 91.43z" _fill="#bfbfbf"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/crossbarCircle.js